import Vue from 'vue';
import { mapMutations, mapState } from 'vuex';

import { store } from './store';
import { router } from './routes';
import { meta } from './js/meta';

import VueResource from 'vue-resource';
Vue.use(VueResource);
Vue.http.options.root = '/';

import VueCookie from 'vue-cookie';
Vue.use(VueCookie);

import VueParallaxJs from 'vue-parallax-js';
Vue.use(VueParallaxJs, { minWidth: 1280 });

import ShoppingCart from '@components/shopping-cart/script.js';
import RightMenu from '@components/right-menu/script.js';
import Cookies from '@components/cookies/script.js';
import TopMenu from '@components/header-menu/script.js';
import LeftMenu from '@components/left-menu/script.js';

Vue.directive('click-outside', {
  bind: function(element, binding, vnode) {
    element.clickOutsideEvent = function(event) {
      if (!(element === event.target || element.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', element.clickOutsideEvent);
  },
  unbind: function(element) {
    document.body.removeEventListener('click', element.clickOutsideEvent);
  },
});

router.beforeEach((to, from, next) => {
  store.dispatch('api/isAuth');

  if (window.innerWidth < 1280) {
    store.commit('params/closeleftMenu');
  }
  window.removeEventListener('scroll', onScrollAnimate);
  [...document.querySelectorAll('button')].forEach((item) => {
    if (item.title === 'select to enable accessability for this content') {
      item.remove();
    }
  });
  linkRemoveActions();
  next();
});

router.afterEach((to, from) => {
  setTimeout(() => {
    onScrollAnimate();
    window.addEventListener('scroll', onScrollAnimate);
  }, 1100);

  setTimeout(() => {
    linkAddActions();
    window.content = undefined;
  }, 200);

  store.dispatch('meta/loadItems', to.path).then(() => {
    meta(store);
  });
});

new Vue({
  el: '#app',
  store,
  router,
  components: {
    'shopping-cart-cmp': ShoppingCart,
    'right-menu-cmp': RightMenu,
    'cookies-cmp': Cookies,
    'header-menu-cmp': TopMenu,
    'left-menu-cmp': LeftMenu,
  },
  data() {
    return {
      headerVisible: false,
    };
  },
  created() {
    this.setSliderItems(headerSlider);
    this.isMobile();
    this.setLeftMenuVisible(window.innerWidth < 1280);
    if (!this.$cookie.get('cookies')) {
      this.$cookie.set('cookies', true, { expires: '1Y' });
      this.toggleRightMenu();
      this.toogleFirstStart();
    }

    this.headerVisible = this.$route.name !== 'main';
    this.setLeftMenuVisible(
      (this.$route.name !== 'main' &&
        this.$route.name !== 'water' &&
        this.$route.name !== 'sales' &&
        this.$route.name !== 'order') ||
        window.innerWidth < 1280
    );
  },
  beforeMount() {
    let content = document.getElementById('content');
    window.content = content.innerHTML;
    content.remove();
  },
  watch: {
    $route: function(to) {
      this.headerVisible = to.name !== 'main';
      this.setLeftMenuVisible(
        (to.name !== 'main' &&
          to.name !== 'water' &&
          to.name !== 'sales' &&
          to.name !== 'order') ||
          window.innerWidth < 1280
      );
    },
  },
  computed: {
    ...mapState('params', ['leftMenuVisible', 'firstStart']),
  },
  methods: {
    ...mapMutations('slider', ['setSliderItems']),
    ...mapMutations('params', [
      'setMobile',
      'setLeftMenuVisible',
      'toogleFirstStart',
      'toggleRightMenu',
    ]),
    isMobile: function() {
      window.innerWidth < 1280 ? this.setMobile(true) : this.setMobile(false);
    },
  },
});

function linkAction(e, item) {
  if (item.getAttribute('to')) {
    router.push(item.getAttribute('to')).catch((err) => {});
  } else {
    let path = item.getAttribute('href');
    if (router.currentRoute.path !== path) {
      router.push(path).catch((err) => {});
    }
  }
}

function composedPathEdge(el) {
  var path = [];

  while (el) {
    path.push(el);

    if (el.tagName === 'HTML') {
      path.push(document);
      path.push(window);

      return path;
    }

    el = el.parentElement;
  }
}

const handleClick = (e) => {
  e.preventDefault();

  const path =
    e.path ||
    (e.composedPath && e.composedPath()) ||
    composedPathEdge(e.target);

  let link = e.target;

  path.some((item) => {
    if (item.classList && item.classList.contains('js-router-link')) {
      link = item;
      return true;
    }
    return false;
  });

  linkAction(e, link);
};

function linkAddActions() {
  document.querySelectorAll('.js-router-link').forEach((item) => {
    item.addEventListener('click', handleClick);
  });
}
function linkRemoveActions() {
  document.querySelectorAll('.js-router-link').forEach((item) => {
    item.removeEventListener('click', handleClick);
  });
}
function isScrolledIntoView(container) {
  if (container) {
    const elementPosition = {
        top: window.pageYOffset + container.getBoundingClientRect().top,
        bottom: window.pageYOffset + container.getBoundingClientRect().bottom,
      },
      windowPosition = {
        top: window.pageYOffset,
        bottom: window.pageYOffset + document.documentElement.clientHeight,
      };
    return (
      elementPosition.bottom > windowPosition.top &&
      elementPosition.top < windowPosition.bottom
    );
  }
  return false;
}
function onScrollAnimate() {
  document
    .querySelectorAll('.js-t-animate:not(.js-t-animate_done)')
    .forEach((item) => {
      if (item && isScrolledIntoView(item) === true) {
        item.classList.add('js-t-animate_done');
        if (
          !item.classList.contains('a-childs') &&
          !item.classList.contains('a-childs-bottom') &&
          !item.classList.contains('a-childs-right') &&
          !item.classList.contains('a-childs-left') &&
          !item.classList.contains('a-children')
        ) {
          item.classList.add('js-t-animate_end');
        } else if (item.classList.contains('a-children')) {
          let index = 0;
          item.parentElement.childNodes.forEach((item1, i) => {
            if (item == item1) {
              index = i;
            }
          });
          let stepTime = 6;
          if (item.classList.contains('_2')) {
            stepTime = 2;
          }
          if (item.classList.contains('_4')) {
            stepTime = 4;
          }
          let timeOut = 0 + 150 * (index % stepTime);
          setTimeout(() => {
            item.classList.add('js-t-animate_end');
          }, timeOut);
        } else {
          let timeOut = 400 + 150 * item.childNodes.length;
          setTimeout(() => {
            item.classList.add('js-t-animate_end');
          }, timeOut);
        }
      }
    });
}



// WEBPACK FOOTER //
// ./src/main.js